import track from './track';
import { convertGuidToInt } from '../common/number-utils';

let currentParticipantId;
let currentSlug;
let currentTenantId;
let currentPage;

export default (store) => () => {
  const { auth, tenant, routing } = store.getState();
  const { href } = location;
  const { id: participantId, email, externalId } = (auth.currentSession && auth.currentSession.user) || {};
  const { pathname, search, hash } = (routing && routing.location) || {};
  const { slug, id: tenantId, integrationType, name: tenantName } = tenant.currentTenant || {};
  const { type: userLevel } = (auth.currentSession && auth.currentSession.session) || {};
  const { userAgent } = navigator;

  const nextPage = `${pathname}${search}${hash}`;

  if (currentParticipantId !== participantId || currentSlug !== slug || currentTenantId !== tenantId) {
    currentParticipantId = participantId;
    currentSlug = slug;
    currentTenantId = tenantId;

    track.config({
      href,
      integrationType,
      orgId: (externalId && convertGuidToInt(externalId)),
      participantId,
      slug,
      tenantId,
      tenantName,
      userAgent,
      userLevel,
      username: email,
    });
  }

  if (currentPage !== nextPage) {
    currentPage = nextPage;
    track.pageView(nextPage);
  }
}



// WEBPACK FOOTER //
// src/tracking/tracking-observer.js